import {FC} from 'react';

export const NoWrap: FC<{children?: React.ReactNode}> = (props) => (
  <span style={{whiteSpace: 'nowrap'}} {...props} />
);
